import { ReactNode } from 'react'
import Header from '../Header/Header'
import Link, { LinkProps } from '../Link/Link'

export interface AccountSectionProps {
  /**
   * Section title
   */
  title: string
  /**
   * Section link
   */
  link?: LinkProps | LinkProps[]
  /**
   * Section content
   */
  children: ReactNode
}

export default function AccountSection({
  title,
  link,
  children,
}: Readonly<AccountSectionProps>) {
  return (
    <div className="w-full border border-neutral-400 px-4 py-4 lg:p-6 rounded-lg">
      <div className="lg:flex lg:items-center lg:justify-between">
        <Header as="h2" className="type-body-2 lg:type-body-1">
          {title}
        </Header>
        {link && (
          <>
            {!Array.isArray(link) && (
              <Link
                className="[&]:p-0 [&]:type-body-7 visited:text-inherit lg:[&]:type-body-5"
                onClick={link?.onClick}
              >
                {link?.title}
              </Link>
            )}
            {Array.isArray(link) && (
              <div className="flex gap-x-6">
                {link.map((item) => (
                  <Link
                    className="[&]:p-0 [&]:type-body-7 visited:text-inherit lg:[&]:type-body-5"
                    onClick={item.onClick}
                    key={item.title}
                  >
                    {item.title}
                  </Link>
                ))}
              </div>
            )}
          </>
        )}
      </div>
      {children && <div className="type-body-8 pt-4 lg:pt-6">{children}</div>}
    </div>
  )
}
